import React, { useCallback, useState } from "react";
import FlusterTopPlayer from "../components/FlusterTopPlayer";
import FlusterButton from "../components/FlusterButton";
import Socket from "socket";
import _ from "lodash";
import FlusterCard from "../components/FlusterCard";
import { motion } from "framer-motion/dist/framer-motion";
import { divVariants, fadeVariants } from "shared/components/animations";
const FLUSAnswerer = ({
  points,
  askerPlayer,
  roomId,
  isAskerPlayer,
  isAnswererPlayer,
  currentPlayerCard,
  screens
}) => {
  const [selectedQuestionCard, setSelectedQuestionCard] = useState({});

  const asker_player_info = _.get(
    screens,
    "asker.3_answerer.info_2",
    " Which question would you like to ask?"
  );
  const asker_player_btn_info = _.get(
    screens,
    "asker.3_answerer.button",
    " This One?"
  );

  const other_player_info = _.get(
    screens,
    "other_players.3_answerer.info_3",

    "It's not your turn yet."
  );
  const answerer_player_info = _.get(
    screens,
    "answerer.3_answerer.info_3",

    "Get ready to answer the question!"
  );
  const buttonClickAction = () => {
    if (isAskerPlayer && _.size(selectedQuestionCard)) {
      const data = {
        action: "play-card-flus",
        roomId,
        playerId: askerPlayer.player_id,
        cardId: selectedQuestionCard.id
      };
      Socket.sendMessage(data);
    }
  };
  const handleQuestionClick = useCallback(
    _.debounce(() => buttonClickAction(), 1000, {
      leading: true,
      trailing: false
    }),
    [selectedQuestionCard]
  );

  const handleQuestionCardClick = (card) => {
    setSelectedQuestionCard(card);
  };
  const activePlayercards = currentPlayerCard?.cards.filter(
    (item) => item.points <= points && item.special === "None"
  );
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="flus-answerer"
    >
      <div className="question-card-main">
        <motion.h4 variants={fadeVariants} className="question-card-heading">
          {isAskerPlayer
            ? asker_player_info
            : isAnswererPlayer
            ? answerer_player_info
            : other_player_info}
        </motion.h4>
        <div
          className={`fluster-card-container ${
            isAskerPlayer
              ? activePlayercards?.length > 1
                ? ""
                : "single-card"
              : ""
          }`}
        >
          {isAskerPlayer ? (
            <>
              {activePlayercards?.map((card, index) => (
                <FlusterCard
                  key={index}
                  card={card}
                  onClick={() => handleQuestionCardClick(card)}
                  selected={
                    isAskerPlayer && selectedQuestionCard.id === card.id
                  }
                />
              ))}
            </>
          ) : (
            <>
              {currentPlayerCard?.cards.map((card, index) => (
                <FlusterCard card={card} key={index} />
              ))}
            </>
          )}
        </div>
      </div>

      {isAskerPlayer && (
        <FlusterButton
          text={asker_player_btn_info}
          onClick={handleQuestionClick}
        />
      )}
    </motion.div>
  );
};

export default FLUSAnswerer;
